<ng-container *ngIf="shouldShow">
    <div class="info" [class.showAvatar]="showAvatar">
        <cm-profile-avatar
            class="info__avatar"
            [imageUrl]="request.image"
            placeholder="/assets/images/user-icon-colored.svg"
        ></cm-profile-avatar>
        <div class="info__message">
            <span class="requestor">{{ requestedBy }}</span> {{ requestOrAssignMessage }}
        </div>
    </div>
    <div class="buttons">
        <div class="btn btn-primary" (click)="openAcceptModal($event)">Accept...</div>
        <div class="btn btn-default" (click)="openRejectModal($event)">Reject</div>
    </div>
</ng-container>
